<!--
 * @Author: 张天昊
 * @Date: 2024-05-17 11:22:05
 * @LastEditTime: 2024-06-04 13:49:08
 * @LastEditors: 张天昊
 * @Description: 卡片外壳
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/CardContainer.vue
-->
<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    bordered: {
      type: Boolean
    }
  },
  setup(props, { expose }) {
    const dynamicClass = ref([]);
    function toggleHighlight() {
      dynamicClass.value.push('highlight-card');
      setTimeout(() => {
        dynamicClass.value.pop();
      }, 1000);
    }
    expose({
      toggleHighlight
    });
    return {
      dynamicClass
    };
  }
});
</script>

<template>
  <div
    class="p-16 bg-white rounded-4"
    :class="[...dynamicClass, { bordered }]"
    @click="$emit('click')"
  >
    <slot />
  </div>
</template>

<style scoped>
@import '../styles/card-shared.css';
.bordered {
  border: 1px solid transparent;
}
</style>
